<template>
<b-container fluid>
  <b-alert v-if="alert.message != ''" :variant="alert.variant">{{alert.message}}</b-alert>
  <h1>Shipment Locator</h1>
  <b-row align-h="center">
    <b-form @submit="searchShipments" inline>
      <b-form-input placeholder="Order ID" v-model="form.orderNumber" class="mx-1" />
      <b-form-input placeholder="Tracking Number" v-model="form.trackingNumber" class="mx-1" />
      <b-form-input placeholder="Ship Method" v-model="form.shipMethod" class="mx-1" />
      <b-form-input placeholder="Computer" v-model="form.computerUsed" class="mx-1" />
      <b-btn type=submit variant=primary class="mx-1">Search Shipments</b-btn>
    </b-form>
  </b-row>
  <section v-if="items.length > 0" class="mx-2">
    <b-row class="mt-2">
      <b-col cols=8>
        <b-form-input v-model="filter" placeholder="Filter" />
      </b-col>
      <b-col>
        <b-pagination
          :current-page="currentPage" :per-page="perPage"
          :total-rows="totalRows" v-model="currentPage"
          align="right" class="mb-0"
        />
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-table
        :items="items" :fields="fields" class="mb-0"
        :busy="busy" :current-page="currentPage" :per-page="perPage"
        :sort-by.sync="sortBy" :striped="true"
        :filter="filter" @filtered="onFilter"
      >
        <template slot="ordernumber" slot-scope="data">
          <router-link target="_blank" :to="{ name: 'View Order', params: { id: data.item.ordernumber} }">
            {{ data.item.ordernumber }}
          </router-link>
        </template>
        <template slot="trackingnumber" slot-scope="data">
          <a v-if="data.item.gateway == 'FEDEX'" :href="'https://www.fedex.com/fedextrack/?trknbr=' + data.item.trackingnumber"
           target="_blank">
            {{ data.item.trackingnumber }}
          </a>
          <a v-else-if="data.item.gateway == 'USPS'" :href="'https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum=' + data.item.trackingnumber"
           target="_blank">
            {{data.item.trackingnumber}}
          </a>
          <a v-else-if="data.item.gateway == 'DHL'" :href="'https://www.dhl.com/us-en/home/tracking.html?tracking-id=' + data.item.trackingnumber + '&submit=1'"
           target="_blank">
            {{data.item.trackingnumber}}
          </a>
          <p v-else>{{ data.item.trackingnumber }}</p>
        </template>
        <template slot="shipmethod" slot-scope="data">
          <p v-html="data.item.shipmethod" />
        </template>
        <template slot="deliverydate" slot-scope="data">
          <NiceDate :value="data.item.deliverydate" :split="true" v-if="data.item.deliverydate != '0001-01-01' && data.item.deliverydate != '1900-01-01'" is-utc :show-time="false" />
        </template>
        <template slot="shiptime" slot-scope="data">
          <NiceDate :value="data.item.shiptime" :split="true" is-utc />
        </template>
        <template slot="emailsent" slot-scope="data">
          <NiceDate :value="data.item.emailsent" :split="true" is-utc v-if="Date.parse(data.item.emailsent)" />
          <span v-else>{{data.item.emailsent}}</span>
        </template>
        <template slot="costestimate" slot-scope="data">
          <p v-if="data.item.costestimate != null">{{data.item.costestimate | formatDollars }}</p>
        </template>
        <template slot="fulfilled" slot-scope="data">
          <span v-if="data.item.fulfilled">Y</span>
          <span v-else>N</span>
        </template>
        <template slot="voided" slot-scope="data">
          <span v-if="data.item.voided">Y <span
                v-if="data.item.voidemailsent"><br><NiceDate
                :value="data.item.voidemailsent" /></span></span>
        </template>
      </b-table>
    </b-row>
  </section>
</b-container>
</template>

<script>
import axios from 'axios';
import NiceDate from '../utility/NiceDate';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    NiceDate,
  },
  data() {
    return {
      alert: {
        variant: 'danger',
        message: '',
      },
      form: {
        orderNumber: '',
        trackingNumber: '',
        shipMethod: '',
        computerUsed: '',
      },
      sortBy: 'ordernumber',
      busy: false,
      fields: [
        { key: 'ordernumber', label: 'Order ID', sortable: true },
        { key: 'trackingnumber', label: 'Tracking Number', sortable: true },
        { key: 'shipmethod', label: 'Ship Method', sortable: true },
        { key: 'shiptime', label: 'Ship Time', sortable: true },
        { key: 'voided', label: 'Voided', sortable: true },
        { key: 'computerused', label: 'Computer Used', sortable: true },
        { key: 'boxsize', label: 'Box Size', sortable: true },
        { key: 'weight', label: 'Weight (lbs)', sortable: true },
        { key: 'customername', label: 'Customer Name', sortable: true },
        { key: 'emailsent', label: 'Email Sent', sortable: true },
        { key: 'shipstatus', label: 'Ship Status', sortable: true },
        { key: 'deliverydate', label: 'Delivery Date', sortable: true },
        { key: 'fulfilled', sortable: true },
        { key: 'costestimate', label: 'Cost Estimate', sortable: true },
      ],
      items: [],
      filter: '',
      perPage: 25,
      currentPage: 1,
      totalRows: 0,
    };
  },
  methods: {
    searchShipments(evt) {
      evt.preventDefault();
      this.alert.message = '';

      this.busy = true;
      this.trimForm();
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/am-old-db/shipping/locator`,
        data: this.form,
      }).then((response) => {
        this.items = response.data;
        this.totalRows = this.items.length;
        if (this.totalRows == 0) {
          this.alert.variant = 'warning';
          this.alert.message = 'No Orders Found';
        }
        this.busy = false;
      }).catch((error) => {
        this.busy = false;
        this.alert.variant = 'danger';
        this.alert.message = 'Failed to search Orders. See console for more information.';
        console.error(error);
      });
    },
    trimForm() {
      this.form.orderNumber = this.form.orderNumber == undefined ? "" : this.form.orderNumber.trim();
      this.form.trackingNumber = this.form.trackingNumber == undefined ? "" : this.form.trackingNumber.trim();
      this.form.shipMethod = this.form.shipMethod == undefined ? "" : this.form.shipMethod.trim();
      this.form.computerUsed = this.form.computerUsed == undefined ? "" : this.form.computerUsed.trim();
    },
    onFilter(items) {
      this.totalRows = items.length;
      this.currentPage = 1;
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/sales-order/ShipmentLocator.vue